import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { drawScene } from '../../utils/draw-GaugePadProfile'
import { Store } from '@ngxs/store';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { Surface } from '@progress/kendo-drawing';
import { environment } from '../../../../environments/environment';
import { CoGs, Cutter } from '../../interfaces/request';
import { IORD_Order, PatchORDCutterMapDto } from '../../interfaces/request.interface';
import { combineLatest, filter, map, Observable, Subject, takeUntil } from 'rxjs';
import { RequestState } from '../../store/state/request.state';
import { OptionState } from '../../store/state/options.state';
import { AvailableCutter } from '../../interfaces/cutterMap';

@Component({
    selector: 'app-reviewrequest-data',
    templateUrl: './reviewrequest-data.component.html',
    styleUrl: './reviewrequest-data.component.css',
    standalone: false
})
export class ReviewrequestDataComponent implements AfterViewInit, OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  private rtaAvailableCutters$!: Observable<AvailableCutter[]>;
  public cutterQuantitiesList: Array<{ cutter: AvailableCutter; qty: number; index: number }> = [];

  constructor(private store: Store) {
    this.cogs$ = this.store.select(RequestState.getCoGs).pipe(
          map(cogs => cogs || {
            RtaNumber: this.draftId,
        ReferenceMaterialNumber: '',
        Ref_PrimaryCutter: '',
        Ref_BackupElement: '',
        Ref_OverallLeach: '',
        Ref_Powder: '',
        Ref_Binder: '',
        Ref_Hardfacing: '',
        Ref_Uppersection: '',
        Ref_OnePiece: false,
        Rta_PrimaryCutter: '',
        Rta_BackupElement: '',
        Rta_OverallLeach: '',
        Rta_Powder: '',
        Rta_Binder: '',
        Rta_Hardfacing: '',
        Rta_Uppersection: '',
        Rta_OnePiece: false,
        Delta_Matrix2Steel: '',
        Total_Cost: '',
        Total_Savings: '',
        HideReference: false,
        Justification: '',
          })
        );
    this.rtaAvailableCutters$ = this.store.select(OptionState.availableCutters);
  }
  @Input() draftId: number = 0;
  @Input() Request?: IORD_Order;
  @Input() cutterMappingInitial?: PatchORDCutterMapDto[];
  @Input() isEjdf: boolean = false;

  public cogs$: Observable<CoGs>;
  public cutterQuantities$!: Observable<{ cutter: AvailableCutter; qty: number, index: number }[]>;
  @ViewChild("surface")
  private surfaceElement: ElementRef | undefined;
  private surface: Surface | undefined;

  columnNumbers: number[] = [];
  keepTogether = ".prevent-split";
  asset_Location = environment.asset_location;
  scale: number = .7;
  printcurrentDate = new Date;
  printcurrentDate_String = this.printcurrentDate.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });

  public CentralDesignRequired: string= "N";
  public Priority: string = "Normal";
  public ExclusionRequest: string = "N";
  public OnePiece: string = "N";
  public Retrofit: string = "N";
  public HasSleeve: string = "N";
  public OculusInfluenced: string = "N";
  public CerebroInfluenced: string = "N";
  public ShortShank: string = "N";
  public Restrictor: string = "N";
  public ReferenceNumber: string = "";
  public blades: any[] = [];
  colorCodes = [{ Id: 1, Color: '#3D37FF' },  { Id: 2, Color: '#FF3737' },  { Id: 3, Color: '#00FF37' },  { Id: 4, Color: '#FF37F3' },  { Id: 5, Color: '#37FFD1' },  { Id: 6, Color: '#FFA137' },
    { Id: 7, Color: '#8E37FF' },  { Id: 8, Color: '#96FF9F' },  { Id: 9, Color: '#FF37A1' },  { Id: 10, Color: '#37A1FF' },  { Id: 11, Color: '#FF37FF' },  { Id: 12, Color: '#37FF8E' },
    { Id: 13, Color: '#FF8E37' },  { Id: 14, Color: '#37FF00' },  { Id: 15, Color: '#FF00FF' },  { Id: 16, Color: '#00FF8E' },  { Id: 17, Color: '#FF3737' },  { Id: 18, Color: '#37FFA1' },
    { Id: 19, Color: '#FF8E8E' },  { Id: 20, Color: '#8E8EFF' },  { Id: 21, Color: '#FF00A1' },  { Id: 22, Color: '#00A1FF' },  { Id: 23, Color: '#A1FF00' },  { Id: 24, Color: '#FFA1FF' },
    { Id: 25, Color: '#A1FF8E' }]
  public valueChange(value: any): void {
    //Add what the change does
  }
  public ngAfterViewInit(): void {
    drawScene(this.createSurface(), this.Request?.steps ?? []);
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.surface) {
      this.surface.destroy();
    }
  }
  getColor(groupNumber: number) {
    const colorIndex = (groupNumber-1);
    if (this.colorCodes[colorIndex] != undefined)
      {return `background-color:${this.colorCodes[colorIndex].Color}; color: #000000;`}
    return 'background-color: grey;'
  }
  getCodeClass(code: string) {
    return code.length > 2 
 }
 public getTableColor = (context: RowClassArgs) => {
  if(context?.dataItem)
  {
    return {[`${context.dataItem.ColorCode}`]: true};
  }
  else return {group: true}
}
  private createSurface(): Surface {
    // Obtain a reference to the native DOM element of the wrapper
    if (!this.surfaceElement) {
      throw new Error("Surface element is not defined.");
    }
    const element = this.surfaceElement.nativeElement;

    // Create a drawing surface
    this.surface = Surface.create(element);

    return this.surface;
  }
  getCogsDeltaColor(rtaCog: string, refCog: string): string | undefined {
    if(parseFloat(rtaCog)>parseFloat(refCog))
      return 'cogsNegative'
    else if(parseFloat(refCog)>parseFloat(rtaCog))
      return 'cogsSavings'
    return 'cogsNeutral'
  }
  getTotalSavingsClass(cost: string | number){
    if(parseFloat(cost?.toString()) > 0)
      return 'cogsSavings';
    else
      return 'cogsNegative';
  }
  getCogDelta(rtaCog: number, refCog: number)
  {
    if(rtaCog>refCog)
      {
        let cogDelta = rtaCog-refCog;
        return '$'+ cogDelta.toFixed(2);
      }
    else if(refCog>rtaCog)
      {
        let cogDelta = rtaCog-refCog;
        return '-$'+ cogDelta.toFixed(2);
      }
    else
        return '$0'
  }
  getRowSpanCutterMap(blade: number){
    let rowSpan = 1;return 1;
  }
  showRowCutterMap(blade: number, row: number){
    let rowSpan = 1;
    if(row===rowSpan)
    return true;
    else
    return false;
  }
  getPDFFilename(){
    return `${this.draftId}-RepairOrder${this.printcurrentDate_String}.pdf`
  }
  getRowRemainingCount(actionCodes: Cutter[])
  {
    var emptyCutters: string[] = [];
    for (let index = actionCodes.length; index < 20; index++) {
      emptyCutters.push("E");
    }
    return emptyCutters
  }
  ngOnInit(): void {
    for (let index = 1; index < 19; index++) {
      this.columnNumbers.push(index);
    }
    this.ExclusionRequest = this.convertTrueFalse(this.Request?.requestExclusion ?? false);
    this.CentralDesignRequired = this.convertTrueFalse(this.Request?.centralDesignRequested ?? false);
    this.OnePiece = this.convertTrueFalse(this.Request?.bit?.onePiece ?? false);
    this.Retrofit = this.convertTrueFalse(this.Request?.bit?.retroFit ?? false);
    this.HasSleeve = this.convertTrueFalse(this.Request?.bit?.sleeve ?? false);
    this.OculusInfluenced = this.convertTrueFalse(this.Request?.isOculusInfluenced ?? false);
    this.CerebroInfluenced = this.convertTrueFalse(this.Request?.orD_Cerebro?.usedCerebroData ?? false);
    this.ShortShank = this.convertTrueFalse(this.Request?.uppersection?.shortShank ?? false);
    this.Restrictor = this.convertTrueFalse(this.Request?.uppersection?.restrictor ?? false);
    this.ReferenceNumber = this.Request?.sapNumbers?.find(s => s.sapNumTypeId === 1)?.number?.toString() ?? '';
    switch (this.Request?.priority) {
      case 1:
        this.Priority = "Urgent";
        break;
      case 2:
        this.Priority = "Hot Rush";
        break;
      case 3:
        this.Priority = "Rush";
        break;
      default:
        this.Priority = "Normal";
        break;
    }

    // Calculate cutter quantities from mapping data
    this.calculateCutterQuantities();
  }

  private calculateCutterQuantities(): void {
    if (!this.cutterMappingInitial || this.cutterMappingInitial.length === 0) {
      this.cutterQuantitiesList = [];
      return;
    }

    this.rtaAvailableCutters$
      .pipe(
        filter(cutters => cutters && cutters.length > 0),
        takeUntil(this.destroy$)
      )
      .subscribe(availableCutters => {
        // Count quantities by pdcCutter_Id
        const qtyMap = this.cutterMappingInitial!
          .filter(m => m.pdcCutter_Id != null)
          .reduce((acc: Record<number, number>, m) => {
            const id = m.pdcCutter_Id!;
            acc[id] = (acc[id] || 0) + 1;
            return acc;
          }, {});

        // Map to cutter details with quantities
        this.cutterQuantitiesList = Object.entries(qtyMap)
          .map(([idStr, qty], idx) => {
            const id = Number(idStr);
            const cutter = availableCutters.find(c => c.pdcCutterID === id);
            return cutter
              ? { cutter, qty, index: idx + 1 }
              : null;
          })
          .filter((x): x is { cutter: AvailableCutter; qty: number; index: number } => x !== null)
          .sort((a, b) => b.qty - a.qty); // Sort by quantity descending
      });
  }

  public convertTrueFalse = (value: boolean): string => {
      if(value)
        return "Y";
      else
        return "N";
  }

  public getTotalCutterCount(): number {
    return this.cutterQuantitiesList.reduce((sum, item) => sum + item.qty, 0);
  }

  public getColorByIndex(index: number): string {
    const colorIndex = index - 1;
    if (this.colorCodes[colorIndex] !== undefined) {
      return this.colorCodes[colorIndex].Color;
    }
    return '#9e9e9e';
  }

  /**
   * Formats a raw value to a string with specified decimal places.
   * Returns '0.00' for null/undefined/NaN values.
   */
  public formatTo(raw: any, decimals = 2): string {
    if (raw == null || raw === '') {
      return (0).toFixed(decimals);
    }
    const n = typeof raw === 'number' ? raw : parseFloat(raw);
    if (isNaN(n)) {
      return (0).toFixed(decimals);
    }
    return n.toFixed(decimals);
  }
}
